'use strict';
import * as $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigation$002ejs from "@ui5/webcomponents-fiori/dist/SideNavigation.js";
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp from "./com.raquo.laminar.keys.-Event-Prop.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.In = null;
  this.Io = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-side-navigation");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$.prototype = $p;
$p.xO = (function() {
  if ((!this.Io)) {
    this.In = new $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp.$c_Lcom_raquo_laminar_keys_EventProp("selection-change");
    this.Io = true;
  }
  return this.In;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002dfiori$002fdist$002fSideNavigation$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$, "io.github.nguyenyou.ui5.webcomponents.laminar.SideNavigation$", ({
  jK: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SideNavigation$ };
